import React, { useContext, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  useTheme,
} from "@mui/material";
import { useSnackbar } from "../../contexts/InfoContext";
import { useAuth } from "../../contexts/AuthContext";
import getRequiredUserData from "../../utils/getBranchInfo";
import ConfirmationDialog from "../VersatileComponents/ConfirmationDialog";
import Fundraising from "../../api/bonusPenality/fundraising";
import useUserClaims from "../../hooks/useUserClaims";
import { SpinnerContext } from "../../contexts/SpinnerContext";

const FundraisingDialog = ({ worker }) => {
  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState(0);
  const [reason, setReason] = useState("");
  const { openSnackbar } = useSnackbar();
  const { user } = useAuth();
  const [openDialog, setOpenDialog] = useState(false);
  const { isSubmitting, setIsSubmitting } = useContext(SpinnerContext);
  const branchData = getRequiredUserData();
  const theme = useTheme();
  const userClaims = useUserClaims(user);

  const handleDeleteIconClick = () => {
    setOpenDialog(true);
  };
  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleOpen = () => {
    if (!branchData.active) {
      openSnackbar("There is not salary table for this branch", "info");
      return;
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAmountChange = (event) => {
    setAmount(Math.abs(parseFloat(event.target.value)));
  };

  const handleReasonChange = (event) => {
    setReason(event.target.value);
  };

  const handleFundraisingSubmit = async () => {
    setOpen(false);
    setIsSubmitting(true);
    handleDialogClose();
    try {
      if (parseInt(amount) === 0) {
        openSnackbar(
          `You are trying to deduct 0 for fundraising from all ${worker}.`,
          "info"
        );
        setAmount(0);
        setReason("");
        setIsSubmitting(false);
        return;
      }
      if (branchData.active !== "") {
        const fundraisingData = {
          salaryTableId: branchData.active,
          branchId: branchData.requiredId,
          amount: parseInt(amount),
          reason: reason,
        };
        const res = await Fundraising(fundraisingData, user, worker);
        openSnackbar(res.data.message, "success");
      }
    } catch (error) {
      openSnackbar(
        error.response?.data?.message || "An error occurred.",
        error.response?.data?.type || "error"
      );
    }
    setAmount(0);
    setReason("");
    setIsSubmitting(false);
  };

  return (
    <div>
      {userClaims.admin ? (
        <Button
          variant="contained"
          disabled={userClaims.superAdmin || isSubmitting}
          color="primary"
          onClick={handleOpen}
        >
          Fundraising
        </Button>
      ) : null}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle sx={{ backgroundColor: theme.palette.background.alt }}>
          Fundraising Deduction
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: theme.palette.background.alt }}>
          <DialogContentText>
            Please enter the fundraising deduction details.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Amount"
            fullWidth
            type="number"
            value={amount}
            onChange={handleAmountChange}
          />
          <TextField
            margin="dense"
            label="Reason"
            fullWidth
            value={reason}
            onChange={handleReasonChange}
          />
        </DialogContent>
        <DialogActions sx={{ backgroundColor: theme.palette.background.alt }}>
          <Button
            onClick={handleClose}
            color="primary"
            variant="contained"
            sx={{ color: theme.palette.secondary[100] }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteIconClick}
            color="primary"
            variant="contained"
            sx={{ color: theme.palette.secondary[100] }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={openDialog}
        handleDialogClose={handleDialogClose}
        handleConfirmed={handleFundraisingSubmit}
        message={`Are you sure you want to deduct ${amount} from all ${worker} for fundraising? Reason: ${reason}`}
        title={`Confirm Fundraising Deduction`}
      />
    </div>
  );
};

export default FundraisingDialog;
